import { render, staticRenderFns } from "./Show.vue?vue&type=template&id=4454aa56&scoped=true"
import script from "./Show.vue?vue&type=script&lang=js"
export * from "./Show.vue?vue&type=script&lang=js"
import style0 from "./Show.vue?vue&type=style&index=0&id=4454aa56&prod&scoped=true&lang=css"
import style1 from "./Show.vue?vue&type=style&index=1&id=4454aa56&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4454aa56",
  null
  
)

export default component.exports